import styled from 'styled-components';
import React, {useState} from "react";
import {isMobileDevice} from "../../../hooks/mobile/isMobile";


const SUser = styled.div`
    display: flex;
    align-items: center;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.bg_active};
    width: ${props => props.isMobile ? "calc(100% - 24px)" : "calc(100% - 24px)"};
    
    ${props => props.isMobile ? "margin-bottom: 4px;" : "margin-bottom: 10px;"}
    padding: ${props => props.isMobile ? "10px" : "8px 10px"};
    
    img {
        width: 48px;
        height: 48px;
        border-radius: 100%;
        ${props => props.isMobile ? "width: 38px; height: 38px; border-radius: 100%;" : ""}
    }
    
    > div {
        margin-right: 15px;
        
    }
    
    > div:last-child {
        ${props => props.isMobile ? "margin-right: 5px;" : ""}
    }
    
    ${props => props.isMobile ? " border-radius: 4px;" : ""}
    
    
    
`;

const SUserName = styled.div`
    display: flex;
    flex-direction: column;
    height: 48px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${props => props.isMobile ? "height: 38px;" : ""}
`;

const STrackButtons = styled.div`
    display: flex;
    flex-grow: 2;
    justify-content: flex-end;
`;

const SUpvote = styled.div`
    display: flex;
    align-items: center;

    span {
        color: #ffffff55;
        cursor: default;
        font-weight: 600;
        ${props => props.isMobile ? "font-size: 14px;" : ""}
    }
    
    span.cross {
        font-size: 28px;
        padding-bottom: 5px;
        cursor: pointer;
        ${props => props.isMobile ? "font-size: 22px;" : ""}
    }
    
    img {
        height: 26px;
        margin-left: 15px;
        cursor: pointer;
        ${props => props.isMobile ? "height: 22px; width: 22px; margin-left: 8px;" : ""}
    }
    
    .track-upvote-arrow {
        filter: grayscale(1) brightness(0.8);
        transition: 0.1s opacity, 0.1s filter;
        ${(props) => props.upvote_disabled ? "opacity: 0.3; cursor: unset;" : ""}
        ${(props) => props.upvoted_by_user ? "filter: unset; cursor: unset;" : ""}
    }

`;


export function RowUser({user, onClick, isMobile=isMobileDevice()}) {
    const [isLoading, setIsLoading] = useState(false);

    return <SUser isMobile={isMobile}>
        <div style={{display: "flex", position: "relative"}}>
            <img src={user.avatar} />
        </div>
        <SUserName isMobile={isMobile}>
            <span style={{fontSize: isMobile ? '14px' : '16px'}}>{user.name}</span>
            <div style={{color: "rgba(255,255,255,0.7)", fontSize: isMobile ? '12px' : '14px'}}></div>
        </SUserName>
        <STrackButtons>
            <SUpvote isMobile={isMobile} onClick={() => {
                onClick(user.id)
            }}>
                <img src={"/icons/settings.svg"} />
            </SUpvote>
        </STrackButtons>

    </SUser>
}
